import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import BouncingDots from '../../components/BouncingDots';
import { ReactComponent as Check } from '../../assets/ic_24_check.svg';

import companyStore from '../../../../store/CompanyStore';
import Styles from '../../Loading.module.scss';

const DAISHIN_COMPANY_ID = '17';

const ListItem = ({ text }) => (
  <div className={Styles.ListItem}>
    <div className={Styles.Oval}>
      <Check />
    </div>
    {text}
  </div>
);

const DaishinPage = observer(({ theme_style }) => {
  useEffect(() => {
    companyStore.fetchCompany(DAISHIN_COMPANY_ID);
  }, []);

  const company = companyStore.company;
  const characterUrl =
    company?.logoFile?.fullUrl ?? company?.symbolLogo?.fullUrl ?? null;
  const companyName = company?.companyName ?? '퀀텀증권';

  return (
    <div className={Styles.Loading} style={theme_style}>
      <div
        className="d-flex justify-center"
        style={{ margin: '40px 0 16px 0' }}
      >
        {characterUrl && (
          <img
            src={characterUrl}
            alt={companyName}
            style={{
              width: '50%',
              maxWidth: '20rem',
              minWidth: '10rem',
              objectFit: 'contain',
              backgroundColor: 'transparent',
            }}
          />
        )}
      </div>
      <div className="d-flex flex-column justify-center align-items-center">
        <div>{companyName} 상담 화면으로 연결 중입니다.</div>
        <div>잠시만 기다려 주세요.</div>
      </div>

      <div
        className="d-flex justify-center"
        style={{ margin: '11px 0 27px 0' }}
      >
        <BouncingDots />
      </div>

      <div className={Styles.List}>
        <ListItem text="대기 하지 않고" />
        <ListItem text="눈으로 보면서" />
        <ListItem text="간편하게 처리" />
      </div>

      <div className={Styles.Footer}>
        <div>이용 중 데이터 요금이 부과 될수 있습니다.</div>
        <div>연결 후 화면에서 선택해주세요.</div>
      </div>
    </div>
  );
});

DaishinPage.propTypes = {};

export default DaishinPage;
